/**
 * `/login` — the pre-auth screen, dressed as the **GMS//OS login terminal**. Logged-out
 * visitors land here (guarded routes redirect to it via {@link RequireAuth}); an already-
 * authenticated visitor bounces to `/`. It renders on the shared {@link GmsScreen} desktop
 * backdrop as a brutalist window — the Omnihook coming online — whose card
 * holds the brand band and the {@link GameLogin} form, visually consistent with the desktop
 * home a player reaches once linked.
 */
import { Navigate } from "@tanstack/react-router";
import { GameLogin } from "../lib/game/GameLogin";
import { useGameSessionContext } from "../lib/game/GameSessionProvider";
import { GmsScreen } from "./home/GmsScreen";
import "./home/gms-login.css";

export function LoginPage() {
  const session = useGameSessionContext();

  if (session.status === "authenticated" && session.actorId !== null) {
    return <Navigate to="/" />;
  }

  const gameName = session.slotList?.gameName;

  return (
    <GmsScreen>
      <div className="gms-login-stage">
        <div className="gms-login-window">
          <div className="gms-login-mat" />
          <div className="gms-card">
            {/* title bar — matches the desktop window chrome */}
            <div className="gms-titlebar">
              <span style={{ letterSpacing: 0 }}>◆</span>
              <span className="gms-titlebar-name">OMNIHOOK TERMINAL</span>
              <div className="gms-titlebar-fill" />
              <span className="gms-login-status">LINK</span>
            </div>

            {/* brand band */}
            <div className="gms-login-brand">
              <span className="gms-login-hex" aria-hidden="true">
                ⬡
              </span>
              <span className="gms-login-wordmark">
                lancer<span className="accent">-vtt</span>
              </span>
              <span className="gms-login-sub">OMNINET LINK</span>
              {gameName && <span className="gms-login-game">{gameName}</span>}
            </div>

            <GameLogin />
          </div>
        </div>
      </div>
    </GmsScreen>
  );
}
